import type React from 'react'

import { NextButton, PrevButton, UpgradeCarouselItem } from './components'
import { useUpgradeCarousel } from './hooks'
import css from './styles.module.css'

type CarouselItem = {
  img: string
  title: string
  description: string
}

interface Props {
  items: CarouselItem[]
  activeIndex: number
  onSetActiveSlide: (index: number) => void
}

export const UpgradeCarousel: React.FC<Props> = ({
  items,
  activeIndex,
  onSetActiveSlide,
}) => {
  const { emblaRef, onPrevButtonClick, onNextButtonClick } = useUpgradeCarousel(
    onSetActiveSlide,
    activeIndex
  )

  return (
    <div>
      <div className={css.carousel_wrap} ref={emblaRef}>
        <div className={css.carousel}>
          {items.map((item, index) => (
            <UpgradeCarouselItem
              key={`${item.title}/${index}`}
              img={item.img}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </div>

      <div className={css.carousel_controls}>
        <PrevButton onClick={onPrevButtonClick} />
        <NextButton onClick={onNextButtonClick} />
      </div>
    </div>
  )
}
